import { DestroyRef, Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { map, mergeMap, take } from 'rxjs/operators';

import { RootState } from '@root/app.state';
import { AuthorizePolicies } from '@platform/platform.state';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { AuthorizeOptions } from './authorize.model';
import { AuthorizeService } from './authorize.service';
import { addParams, extractParams } from './params-helper';

@Directive({
  selector: '[appShowAuthorize]',
  standalone: true,
})
export class ShowAuthorizeDirective implements OnInit {
  @Input() appShowAuthorize!: AuthorizePolicies;
  @Input() appShowAuthorizeOptions!: AuthorizeOptions;

  constructor(
    private authorizeService: AuthorizeService,
    private store$: Store<RootState>,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit() {
    if (!this.appShowAuthorize) {
      this.viewContainer.clear();
      return;
    }

    this.store$
      .pipe(
        select((state) => state.router),
        map((router) => extractParams(router.state.root)),
        map((params) => addParams(params, this.appShowAuthorizeOptions?.values)),
        mergeMap((params) => this.authorizeService.isAuthorized(this.appShowAuthorize, params)),
        take(1),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((isAuthorized) => {
        if (isAuthorized) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      });
  }
}
